import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BusinessFuel } from '../models/business-fuel.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FuelService } from '../services/fuel.service';


@Component({
  selector: 'app-edit-fuel',
  templateUrl: './edit-fuel.component.html',
  styleUrls: ['./edit-fuel.component.scss']
})
export class EditFuelComponent implements OnInit {
  fuel: BusinessFuel;
  originalFuel: BusinessFuel;
  isNew = false;
  isLoading = false;
  businessID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  selectedType: string;
  selectedBrand: string;
  selectedService: string;
  selectedPrice: string;

  constructor(private _matDialogRef: MatDialogRef<EditFuelComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _fuelService: FuelService) {
    this.fuel = data.fuel || new BusinessFuel();
    this.isNew = data.isNew || false;
    if (this.isNew) {
      this.fuel.otherInfo = '';
    }
    this.businessID = data.busID;
    this.originalFuel = Object.assign(new BusinessFuel(), data.fuel);
    this.itemsToChange = new Set<number> ();
    this.selectedType = this.fuel.fuelType || '';
    this.selectedBrand = this.fuel.fuelBrand || '';
    this.selectedService = BusinessFuel.formatServiceType(this.fuel.service);
    this.selectedPrice = this.fuel.price ? this.fuel.price.toFixed(2) : '';
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      type: new FormControl(this.selectedType, [Validators.required]),
      brand: new FormControl(this.selectedBrand, [Validators.required]),
      fee: new FormControl(this.selectedPrice, [Validators.required, Validators.maxLength(6),
        Validators.pattern('\\d+\\.\\d\\d')]),
      service: new FormControl(this.selectedService, [Validators.required]),
      note: new FormControl(this.fuel.otherInfo, [Validators.maxLength(50)])
    });
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.fuel.fuelType = this.formGroup.get('type').value;
      this.fuel.fuelBrand = this.formGroup.get('brand').value;
      this.fuel.service = this.formGroup.get('service').value;
      this.fuel.otherInfo = this.formGroup.get('note').value;
      this.fuel.price = this.formGroup.get('fee').value;
      if (this.isNew) {
        res = await this._fuelService.postBusinessFuel(this.businessID, this.fuel);
        this.fuel = BusinessFuel.parse(res);
      } else {
        res = await this._fuelService.putBusinessFuel(this.businessID, this.fuel);
        Object.assign(this.fuel, BusinessFuel.parse(res));
        this.fuel = BusinessFuel.parse(res);
      }
      this.close({cancelBtnClicked: false, success: true, contact: this.fuel});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.fuel, this.originalFuel);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
}
